module.exports = __webpack_public_path__ + "4da69ac632ac277924a9b13edeb5e9ef.jpg";